<template>
    <div class="flex-1 flex flex-col">
            <!-- 顶部搜索区 -->
<!--            <div class="p-4 bg-white border-b border-gray-200">
                <div class="w-full max-w-none px-4">
                    <div class="flex items-center bg-gray-50 rounded-lg p-2">
                        <input type="text" placeholder="请输入您的问题" class="flex-1 px-4 py-2 bg-transparent border-none outline-none text-sm">
                        <button class="p-2 text-gray-500 hover:text-primary">
                            <i class="fas fa-microphone"></i>
                        </button>
                        <button class="p-2 text-gray-500 hover:text-primary">
                            <i class="fas fa-paperclip"></i>
                        </button>
                        <button class="ml-2 px-6 py-2 bg-primary text-white rounded-button hover:bg-opacity-90 flex items-center">
                            <i class="fas fa-search mr-2"></i>
                            搜索
                        </button>
                    </div>
                    <div class="flex mt-4 space-x-2">
                        <button class="px-3 py-1 text-sm bg-white rounded-full border border-gray-200 hover:border-primary hover:text-primary">
                            热门问题
                        </button>
                        <button class="px-3 py-1 text-sm bg-white rounded-full border border-gray-200 hover:border-primary hover:text-primary">
                            最新问题
                        </button>
                        <button class="px-3 py-1 text-sm bg-white rounded-full border border-gray-200 hover:border-primary hover:text-primary">
                            我的问题
                        </button>
                    </div>
                </div>
            </div>-->

            <!-- 对话内容区 -->
            <div class="flex-1 overflow-y-auto p-4" ref="messageContainer" @scroll="handleScroll">
                <div class="w-full max-w-none px-4 space-y-6">
                    <!-- 加载更多历史记录提示 -->
                    <div v-if="isLoadingMore" class="text-center py-4">
                        <div class="inline-flex items-center px-4 py-2 bg-gray-100 text-gray-800 rounded-lg">
                            <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-gray-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                            </svg>
                            正在加载更多历史记录...
                        </div>
                    </div>

                    <!-- 历史记录加载提示 -->
                    <div v-if="isLoadingHistory" class="text-center py-4">
                        <div class="inline-flex items-center px-4 py-2 bg-blue-100 text-blue-800 rounded-lg">
                            <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-blue-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                            </svg>
                            正在加载历史对话记录...
                        </div>
                    </div>

                    <!-- 无历史记录提示 -->
                    <div v-if="!isLoadingHistory && messages.length === 0" class="text-center py-8">
                        <div class="bg-gray-50 rounded-lg p-6">
                            <p class="text-gray-600 mb-4">暂无对话记录</p>
                            <p class="text-sm text-gray-500">开始对话后，您的聊天记录将自动保存</p>
                        </div>
                    </div>

                    <!-- 对话消息 -->
                    <div v-for="(message, index) in messages" 
                    :key="index"
                        :class="['chat-bubble', 'chat-bubble-' + message.type, { 'relative': message.type === 'left' }]">
                        
                        <!-- 收藏按钮 - 贴在气泡顶部（仅AI回答消息） -->
                        <button 
                            v-if="message.type === 'left'"
                            @click="toggleFavorite(message, index)"
                            :class="[
                                'absolute -top-2 left-4 w-5 h-5 rounded-full flex items-center justify-center transition-all duration-200 shadow-sm z-10',
                                message.isFavorited 
                                    ? 'bg-yellow-400 text-white hover:bg-yellow-500' 
                                    : 'bg-gray-100 text-gray-400 hover:bg-gray-200'
                            ]"
                            :title="message.isFavorited ? '取消收藏' : '收藏此回答'"
                        >
                            <i :class="message.isFavorited ? 'fas fa-star text-xs' : 'far fa-star text-xs'"></i>
                        </button>
                        
                        <!-- 问题反馈按钮 - 贴在气泡顶部（仅AI回答消息） -->
                        <button 
                            v-if="message.type === 'left'"
                            @click="openFeedbackDialog(message, index)"
                            :class="[
                                'absolute -top-2 left-12 w-5 h-5 rounded-full flex items-center justify-center transition-all duration-200 shadow-sm z-10',
                                message.hasFeedback 
                                    ? 'bg-blue-500 text-white hover:bg-blue-600' 
                                    : 'bg-gray-100 text-gray-400 hover:bg-gray-200'
                            ]"
                            :title="message.hasFeedback ? '查看问题反馈' : '添加问题反馈'"
                        >
                            <i :class="message.hasFeedback ? 'fas fa-question text-xs' : 'far fa-question text-xs'"></i>
                        </button>
                        
                        <!-- AI回答消息 -->
                        <div v-if="message.type === 'left'">
                            <!-- 回答内容 -->
                            <div class="text-gray-900" v-html="renderMarkdown(message.content)"></div>
                        </div>
                        
                        <!-- 用户问题消息 -->
                        <p v-else>{{ message.content }}</p>
                    </div>

                     <!-- <div class="chat-bubble chat-bubble-right">
                        <p>您好，我想了解一下党建工作的相关规定。</p>
                    </div>
                    <div class="chat-bubble chat-bubble-left">
                        <div class="text-gray-900">
                            <p class="mb-4">根据《中国共产党支部工作条例》，党建工作主要包含以下几个方面：</p>
                           <ol class="list-decimal pl-4 mb-4">
                                <li class="mb-2">组织生活会制度</li>
                                <li class="mb-2">党员发展和教育管理</li>
                                <li class="mb-2">党费收缴使用和管理</li>
                                <li class="mb-2">党内监督和纪律约束</li>
                            </ol> 
                           <div class="bg-gray-50 p-3 rounded-lg text-sm">
                                <div class="font-medium mb-2">参考文献：</div>
                                <div class="text-gray-600">
                                    1. 《中国共产党支部工作条例》<br>
                                    2. 《党支部标准化规范化建设指南》
                                </div>
                            </div>
                        </div>
                    </div> -->
                </div>
            </div>
            <div v-if="!isConnected" class="connection-status">
                连接已断开，正在重新连接...
            </div>

            <!-- 底部输入区 -->
            <div class="p-4 bg-white border-t border-gray-200">
                <div class="w-full max-w-none px-4">
                    <div class="flex items-start">
                        <div class="flex-1 bg-gray-50 rounded-lg p-2">
                            <textarea @keydown.enter.prevent="handleEnterKey" v-model="inputMessage" :readonly="!isConnected && !isWriting" :disabled="!isConnected && !isWriting" placeholder="请输入您的问题..." class="w-full h-20 p-2 bg-transparent border-none outline-none resize-none text-sm"></textarea>
                            <div class="flex items-center justify-between pt-2 border-t border-gray-200">
                                <div class="flex space-x-2" style="visibility:hidden">
                                    <button 
                                        @click="startNewConversation" 
                                        class="px-4 py-2 text-gray-600 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors duration-200 flex items-center space-x-2"
                                        :disabled="isWriting"
                                    >
                                        <i class="fas fa-plus"></i>
                                        <span>发起新对话</span>
                                    </button>
                                </div>
                                <div class="flex space-x-2">
                                    <button @click="sendMessage" class="px-6 py-2 text-white rounded-button transition-all duration-300"
                                            :class="{
                                              'hover:bg-opacity-90': isConnected && !isWriting && inputMessage.trim(),
                                              'bg-gray-400': !isConnected || (!isWriting && !inputMessage.trim()),
                                              'bg-primary': isConnected && !isWriting && inputMessage.trim(),
                                              'bg-blue-500 animate-pulse': isWriting
                                            }"
                                        :disabled="!isConnected || isWriting || !inputMessage.trim()"
                                    >
                                        <span v-if="!isWriting">发送</span>
                                        <span v-else class="flex items-center">
                                            <svg class="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                            </svg>
                                            正在回答中...
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <!-- 问题反馈弹窗 -->
            <div v-if="showFeedbackDialog" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div class="bg-white rounded-lg p-6 w-full max-w-md mx-4 max-h-[55vh] overflow-y-auto">
                <h3 class="text-lg font-semibold text-gray-900 mb-4">
                    请输入您对于该回答的疑问，保存后该问答以及疑问内容将发送给管理员做疑问解答！
                </h3>
                
                <!-- 问答内容预览 -->
                <div class="mb-4 p-3 bg-gray-50 rounded-lg">
                    <div class="text-sm text-gray-600 mb-2">
                        <strong>问题：</strong>
                        <span v-html="getQuestionForFeedback()"></span>
                    </div>
                    <div class="text-sm text-gray-600">
                        <strong>回答：</strong>
                        <span v-html="getAnswerForFeedback()"></span>
                    </div>
                </div>
                
                <!-- 疑问输入框 -->
                <div class="mb-4">
                    <label class="block text-sm font-medium text-gray-700 mb-2">
                        您的疑问：
                    </label>
                    <textarea
                        v-model="feedbackQuestion"
                        class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        rows="4"
                        maxlength="300"
                        placeholder="请输入您对该回答的疑问..."
                    ></textarea>
                    <div class="text-right text-sm text-gray-500 mt-1">
                        {{ feedbackQuestion.length }}/300
                    </div>
                </div>
                
                <!-- 按钮组 -->
                <div class="flex justify-end space-x-3">
                    <button
                        @click="closeFeedbackDialog"
                        class="px-4 py-2 text-gray-600 bg-gray-100 rounded-md hover:bg-gray-200 transition-colors duration-200"
                    >
                        取消
                    </button>
                    <button
                        @click="submitFeedback"
                        :disabled="isSubmittingFeedback || !feedbackQuestion.trim()"
                        class="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors duration-200"
                    >
                        {{ isSubmittingFeedback ? '提交中...' : '确定保存' }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
.connection-status {
    margin: 10px auto;
    padding: 8px;
    border-radius: 5px;
    background-color: #F56C6C;
    color: white;

}
.chat-bubble-error {
  color: #F56C6C;
  background: #fef0f0;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
}
</style>
<script>

import SockJS from 'sockjs-client';
import { marked } from 'marked';

import markdownit from 'markdown-it';
import graphvizPlugin from 'markdown-it-graphviz'
import { Graphviz } from '@hpcc-js/wasm'
import hljs from 'highlight.js';
import 'highlight.js/styles/github.css';

import markdownItMermaid from 'markdown-it-mermaid'
import mermaid from 'mermaid'

import DOMPurify from 'dompurify';

marked.setOptions({
  gfm: true,
  breaks: true,
  highlight: function (code, lang) {
    return code;
  }
});

mermaid.initialize({
  startOnLoad: true,
  theme: 'default'
})

export default {
  name: 'Chat',
  data() {
    return {
      ws: null,
      messages: [],
      inputMessage: '',
      isConnected: false,
      isWriting: false,
      reconnectAttempts: 0,
      maxReconnectAttempts: 5,
      currentResponse: '',
      md: null,
      content: '',
      userId: null, // 当前用户ID
      isLoadingHistory: false, // 是否正在加载历史记录
      isLoadingMore: false, // 是否正在加载更多历史记录
      hasMoreHistory: true, // 是否还有更多历史记录
      currentPage: 0, // 当前加载的历史记录页码
             pageSize: 5, // 每次加载的问答对数量（实际加载10条消息）
      isUserScrolling: false, // 用户是否正在手动滚动
      lastScrollTop: 0, // 上次滚动位置
      autoScrollToBottom: true, // 是否自动滚动到底部
      singleLoginCheckTimer: null, // 单点登录检查定时器
      tokenExpirationTimer: null, // token过期检查定时器
      favoriteStatus: {}, // 收藏状态缓存 {messageIndex: {isFavorited: boolean, favoriteId: number}}
      isCheckingFavorite: false, // 是否正在检查收藏状态
      // 问题反馈相关
      showFeedbackDialog: false, // 是否显示问题反馈弹窗
      feedbackQuestion: '', // 问题反馈内容
      feedbackAnswer: '', // 回答内容
      feedbackMessageIndex: -1, // 当前反馈的消息索引
      feedbackStatus: {}, // 反馈状态缓存 {messageIndex: {hasFeedback: boolean, feedbackId: number}}
      isSubmittingFeedback: false // 是否正在提交反馈
    }
  },

  async mounted() {
    // 正确初始化 graphviz
    const graphviz = await Graphviz.load()

    this.md = new markdownit({
      html:         true,        // 在源码中启用 HTML 标签
      xhtmlOut:     true,        // 使用 '/' 来闭合单标签 （比如 <br />）。
      // 这个选项只对完全的 CommonMark 模式兼容。
      breaks:       false,        // 转换段落里的 '\n' 到 <br>。
      langPrefix:   'language-',  // 给围栏代码块的 CSS 语言前缀。对于额外的高亮代码非常有用。
      linkify:      true,        // 将类似 URL 的文本自动转换为链接。

      // 启用一些语言中立的替换 + 引号美化
      typographer:  true,

      // 双 + 单引号替换对，当 typographer 启用时。
      // 或者智能引号等，可以是 String 或 Array。
      //
      // 比方说，你可以支持 '«»„"' 给俄罗斯人使用， '„"‚''  给德国人使用。
      // 还有 ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] 给法国人使用（包括 nbsp）。
      // quotes: '"'"'"'"'"', // 暂时注释掉有问题的配置
      quotes: '“”‘’',
      // 高亮函数，会返回转义的HTML。
      // 或 '' 如果源字符串未更改，则应在外部进行转义。
      // 如果结果以 <pre ... 开头，内部包装器则会跳过。
      highlight: function (str, lang) {
        if (lang && hljs.getLanguage(lang)) {
          try {
            return hljs.highlight(lang, str).value;
          } catch (__) {}
        }

        return ''; // 使用额外的默认转义
      }
    }).use(graphvizPlugin, {
      graphviz,       // 传入 graphviz 实例
      engine: 'dot',  // 渲染引擎 (dot, neato, fdp 等) 
      format: 'svg'   // 输出格式
    })
    // .use(markdownItMermaid, {
    //   // 插件配置
    //   mermaid: mermaid
    // });

    this.initWebSocket()
    
    // 加载用户历史对话记录
    await this.loadChatHistory()
    
    // 启动定期检查单点登录
    this.startSingleLoginCheck()
    
    // 启动token过期检查
    this.startTokenExpirationCheck()
    
    // 添加页面可见性检测
    this.setupPageVisibilityDetection()
  },


  beforeDestroy() {
    this.closeWebSocket()
    // 清理单点登录检查定时器
    if (this.singleLoginCheckTimer) {
      clearInterval(this.singleLoginCheckTimer);
      this.singleLoginCheckTimer = null;
    }
    
    // 清理token过期检查定时器
    if (this.tokenExpirationTimer) {
      clearInterval(this.tokenExpirationTimer);
      this.tokenExpirationTimer = null;
    }
  },
  methods: {
    // 开启新对话
    async startNewConversation() {
      try {
        // 检查是否有当前对话
        if (this.messages.length === 0) {
          alert('当前没有对话内容，无法开启新对话');
          return;
        }

        // 获取当前sessionId
        const currentSessionId = localStorage.getItem('sessionId');
        if (!currentSessionId) {
          alert('无法获取当前会话ID');
          return;
        }

        // 获取当前对话的首次问题作为标题
        const firstQuestion = this.getFirstQuestion();
        if (!firstQuestion) {
          alert('无法获取对话标题');
          return;
        }

        // 保存当前对话到历史记录
        await this.saveConversationToHistory(currentSessionId, firstQuestion);

        // 清空当前对话
        this.messages = [];
        this.inputMessage = '';

        // 获取新的sessionId
        const newSessionId = await this.getNewSessionId();
        if (newSessionId) {
          localStorage.setItem('sessionId', newSessionId);
          alert('新对话已开启');
        } else {
          alert('获取新会话ID失败，但对话已清空');
        }

      } catch (error) {
        console.error('开启新对话失败:', error);
        alert('开启新对话失败，请重试');
      }
    },

    // 获取当前对话的首次问题
    getFirstQuestion() {
      for (let i = 0; i < this.messages.length; i++) {
        if (this.messages[i].type === 'right') {
          return this.messages[i].content;
        }
      }
      return null;
    },

    // 保存对话到历史记录
    async saveConversationToHistory(sessionId, title) {
      try {
        const response = await fetch(`${process.env.VUE_APP_API_BASE_URL}/api/chat-messages/save-conversation`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          },
          body: JSON.stringify({
            sessionId: sessionId,
            title: title,
            messages: this.messages
          })
        });

        const result = await response.json();
        if (result.code !== 200) {
          throw new Error(result.message || '保存对话失败');
        }

        // 触发父组件刷新历史记录
        this.$emit('conversation-saved');
        
      } catch (error) {
        console.error('保存对话到历史记录失败:', error);
        throw error;
      }
    },

    // 获取新的sessionId
    async getNewSessionId() {
      try {
        const response = await fetch(`${process.env.VUE_APP_API_BASE_URL}/api/chat-messages/new-session`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        });

        const result = await response.json();
        if (result.code === 200 && result.data && result.data.sessionId) {
          return result.data.sessionId;
        } else {
          throw new Error(result.message || '获取新会话ID失败');
        }
      } catch (error) {
        console.error('获取新会话ID失败:', error);
        return null;
      }
    },

    // 加载历史对话
    async loadConversation(conversation) {
      try {
        // 如果conversation已经包含messages数据（从HistoryConversations传递过来）
        if (conversation.messages && conversation.messages.length > 0) {
          console.log('从HistoryConversations传递的消息数据:', conversation.messages);
          
          // 清空当前消息
          this.messages = [];
          
          // 加载历史消息
          const messages = conversation.messages;
          for (let i = 0; i < messages.length; i++) {
            const msg = messages[i];
            const messageType = msg.messageType === 'QUESTION' ? 'right' : 'left';
            // 解码Unicode内容
            const decodedContent = this.decodeUnicode(msg.content);
            this.appendMessage(messageType, decodedContent);
          }
          
          // 滚动到底部
          this.$nextTick(() => {
            this.scrollToBottom();
          });
          
          return;
        }

        // 如果没有消息数据，调用API获取
        const token = localStorage.getItem('token');
        if (!token) {
          alert('用户未登录');
          this.$router.push('/login');
          return;
        }

        // 调用新的API端点来处理历史对话加载
        const response = await fetch(`${process.env.VUE_APP_API_BASE_URL}/api/chat-messages/load-history-conversation`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({
            conversationId: conversation.id
          })
        });

        const result = await response.json();
        
        if (result.code === 200 && result.data) {
          const data = result.data;
          
          // 更新sessionId
          localStorage.setItem('sessionId', data.sessionId);
          
          // 清空当前消息
          this.messages = [];
          
          // 加载历史消息
          const messages = data.messages || [];
          for (let i = 0; i < messages.length; i++) {
            const msg = messages[i];
            const messageType = msg.messageType === 'QUESTION' ? 'right' : 'left';
            // 解码Unicode内容
            const decodedContent = this.decodeUnicode(msg.content);
            this.appendMessage(messageType, decodedContent);
          }
          
          // 滚动到底部
          this.$nextTick(() => {
            this.scrollToBottom();
          });
          
          // 显示操作结果
          alert(data.message || '对话已加载');
        } else {
          alert(result.message || '加载对话失败');
        }
      } catch (error) {
        console.error('加载对话失败:', error);
        alert('加载对话失败');
      }
    },

    // 解码Unicode字符串
    decodeUnicode(str) {
      if (!str) return '';
      
      try {
        // 处理Unicode编码的字符串
        return str.replace(/\\u[\dA-Fa-f]{4}/g, function(match) {
          return String.fromCharCode(parseInt(match.replace(/\\u/g, ''), 16));
        });
      } catch (error) {
        console.error('Unicode解码失败:', error);
        return str; // 如果解码失败，返回原字符串
      }
    },

    initWebSocket() {
      try {
        // 获取用户token
        const token = localStorage.getItem('token');
        if (!token) {
          console.error('未找到用户token，无法建立WebSocket连接');
          this.appendMessage('error', '用户未登录，请先登录');
          return;
        }
        
        // 在URL中添加token参数
        const wsUrl = `${process.env.VUE_APP_WS_BASE_URL}/chat?token=${encodeURIComponent(token)}`;
        const sockjs = new SockJS(wsUrl);
        this.ws = sockjs;
        
        this.ws.onopen = () => {
          console.log('WebSocket连接已建立');
          this.isConnected = true;
          this.reconnectAttempts = 0;
        };
        
        this.ws.onmessage = (event) => {
          if (event.data) {
            // 接收消息前立即检查登录状态
            this.checkSingleLoginStatusImmediate().then((isKickedOut) => {
              if (isKickedOut) {
                console.log('用户已被踢出，忽略接收的消息');
                return;
              }
              
              // 登录状态正常，处理消息
              // 检查是否是结束标识符
              if (event.data === '---====:::End') {
                this.isWriting = false;
                return;
              }
              
              try {
                const response = JSON.parse(event.data);
                if (response.error) {
                  this.appendMessage('error', response.error);
                  this.isWriting = false;
                } else {
                  setTimeout(() => {this.appendMessage('left', response.content || event.data);}, 1200);
                }
              } catch (e) {
                this.appendMessage('left', event.data);
              }
            });
          }
        };
        
        this.ws.onerror = (error) => {
          console.error('WebSocket错误:', error);
          this.isConnected = false;
          this.appendMessage('error', '连接发生错误，正在尝试重新连接...');
          this.isWriting = false
        };
        
        this.ws.onclose = () => {
          console.log('WebSocket连接已关闭');
          this.isConnected = false;
          this.reconnect();
        };
      } catch (error) {
        console.error('WebSocket初始化失败:', error);
        this.isConnected = false;
        this.appendMessage('error', '连接初始化失败，请刷新页面重试');
      }
    },
    
    closeWebSocket() {
      if (this.ws) {
        this.ws.close()
        this.ws = null
      }
    },
    
    reconnect() {
      if (this.reconnectAttempts < this.maxReconnectAttempts) {
        this.reconnectAttempts++
        console.log(`尝试重新连接... (${this.reconnectAttempts}/${this.maxReconnectAttempts})`)
        setTimeout(() => {
          this.initWebSocket()
        }, 3000)
      } else {
        // 重连失败后，检查token有效性
        console.log('WebSocket重连失败，检查token有效性');
        this.checkTokenAndRedirect();
      }
    },
    
    // 检查token并重定向
    async checkTokenAndRedirect() {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          this.redirectToLogin('Token不存在');
          return;
        }
        
        const response = await fetch(`${process.env.VUE_APP_API_BASE_URL}/api/auth/validate-token`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': token
          }
        });
        
        const result = await response.json();
        
        if (result.code !== 200 || !result.valid) {
          this.redirectToLogin(result.message || 'Token已过期');
              } else {
        // Token有效但WebSocket连接失败，显示错误信息
        this.appendMessage('error', 'WebSocket连接失败，请刷新页面重试');
      }
    } catch (error) {
      console.error('检查token失败:', error);
      this.redirectToLogin('网络错误，请重新登录');
    }
  },
  
  // 重定向到登录页面
  redirectToLogin(message) {
    console.log('重定向到登录页面:', message);
    // 清除本地存储
    localStorage.removeItem('token');
    localStorage.removeItem('sessionId');
    localStorage.removeItem('displayName');
    localStorage.removeItem('loginAccount');
    localStorage.removeItem('userId');
    
    // 显示提示信息
    alert(`连接失败：${message}，即将跳转到登录页面`);
    
    // 跳转到登录页面
    this.$router.push('/login');
  },
  
  handleEnterKey(event) {
      // 如果按下 Shift+Enter，允许换行
      if (event.shiftKey) {
        return;
      }
      // 否则发送消息
      this.sendMessage();
    },
    
    sendMessage() {
      if (this.inputMessage.trim() && this.isConnected) {
        // 发送消息前立即检查登录状态
        this.checkSingleLoginStatusImmediate().then((isKickedOut) => {
          if (isKickedOut) {
            console.log('用户已被踢出，取消发送消息');
            return;
          }
          
          // 登录状态正常，继续发送消息
          this.isWriting = true;
          try {
            this.ws.send(this.inputMessage);
            this.appendMessage('right', this.inputMessage);
            this.inputMessage = '';
          } catch (error) {
            console.error('发送消息失败:', error);
            this.isConnected = false;
          }
        });
      }
    },
    
    renderMarkdown(content) {
      return this.md.render(content);
    },
    
    // 过滤特殊字符
    filterSpecialChars(content) {
      if (typeof content !== 'string') return content;
      // 过滤 ##数字$$ 格式的特殊字符
      return content.replace(/##\d+\$\$/g, '');
    },

    // Unicode解码方法
    decodeUnicode(content) {
      if (typeof content !== 'string') return content;
      
      // 解码Unicode格式的字符串
      // 优先处理 \uXXXX 格式，如果不存在则处理 uXXXX 格式
      if (content.includes('\\u')) {
        // 如果包含 \uXXXX 格式，使用这种格式解码
        return content.replace(/\\u([0-9a-fA-F]{4})/g, (match, hex) => {
          return String.fromCharCode(parseInt(hex, 16));
        });
      } else if (content.includes('u') && /u[0-9a-fA-F]{4}/.test(content)) {
        // 如果包含 uXXXX 格式，使用这种格式解码
        return content.replace(/u([0-9a-fA-F]{4})/g, (match, hex) => {
          return String.fromCharCode(parseInt(hex, 16));
        });
      }
      
      // 如果都不包含，返回原内容
      return content;
    },

    // Unicode编码方法
    encodeUnicode(content) {
      if (typeof content !== 'string') return content;
      
      // 将字符串编码为Unicode格式
      let result = '';
      for (let i = 0; i < content.length; i++) {
        const char = content.charAt(i);
        const charCode = char.charCodeAt(0);
        
        // 如果是ASCII字符（0-127），直接保留
        if (charCode < 128) {
          result += char;
        } else {
          // 非ASCII字符转换为Unicode格式
          result += '\\u' + charCode.toString(16).padStart(4, '0');
        }
      }
      
      return result;
    },

    appendMessage(type, content) {
      if (type === 'right') {
        this.messages.push({
          type,
          content,
          isFavorited: false,
          favoriteId: null
        });
        this.currentResponse = '';
        this.messages.push({
          type: 'left',
          content: '',
          isFavorited: false,
          favoriteId: null,
          hasFeedback: false,
          feedbackId: null
        });
        // 用户发送消息后，启用自动滚动
        this.autoScrollToBottom = true;
      } else if (type === 'left') {
        // AI回答...
        // this.currentResponse += content;
        // 启动流式处理（实际应替换为WebSocket或Fetch流式处理）
        this.processStream(content);
        // AI回答时，启用自动滚动
        this.autoScrollToBottom = true;
      } else {
        this.messages.push({
          type,
          content,
          isFavorited: false,
          favoriteId: null
        });
      }
      
      this.$nextTick(() => {
        this.scrollToBottom();
      });

      this.$nextTick(() => {
        mermaid.run()
      })
    },


    // 流式处理函数
    processStream(dataArray) {
      // 过滤特殊字符
      const filteredData = this.filterSpecialChars(dataArray);
      
      // 合并新内容（避免重复）
      let currentText = this.messages[this.messages.length - 1].content
      const newText = filteredData.replace(currentText, '');
      if (newText.length > 0) {
        currentText += newText;
        if (this.messages.length > 0) {
          this.messages[this.messages.length - 1].content = currentText;
          
          // 流式更新时，如果启用了自动滚动，则滚动到底部
          if (this.autoScrollToBottom) {
            this.$nextTick(() => {
              this.scrollToBottom();
            });
          }
        }
      }
    },

    // 获取当前用户ID
    getCurrentUserId() {
      try {
        // 优先从localStorage获取用户ID
        const userId = localStorage.getItem('userId');
        if (userId) {
          return parseInt(userId);
        }
        
        // 如果localStorage中没有，尝试从JWT token中解析
        const token = localStorage.getItem('token');
        if (token) {
          const payload = JSON.parse(atob(token.split('.')[1]));
          return payload.userId || payload.sub || null;
        }
      } catch (error) {
        console.error('获取用户ID失败:', error);
      }
      return null;
    },

    // 加载聊天历史记录（最新的5条）
    async loadChatHistory() {
      try {
        this.userId = this.getCurrentUserId();
        if (!this.userId) {
          console.warn('无法获取用户ID，跳过历史记录加载');
          return;
        }

        this.isLoadingHistory = true;
        this.currentPage = 0;
        console.log('开始加载用户最新历史记录，用户ID:', this.userId);

        const response = await fetch(`${process.env.VUE_APP_API_BASE_URL}/api/chat-messages/user/${this.userId}/history`);
        const result = await response.json();

        if (result.code === 200 && result.data && result.data.length > 0) {
          console.log('成功加载最新历史记录，共', result.data.length, '条消息');
          
          // 清空现有消息
          this.messages = [];
          
          // 按时间顺序添加历史消息
          result.data.forEach(message => {
            if (message.messageType === 'QUESTION') {
              this.messages.push({
                type: 'right',
                content: this.decodeUnicode(message.content),
                isFavorited: false,
                favoriteId: null
              });
            } else if (message.messageType === 'ANSWER') {
              this.messages.push({
                type: 'left',
                content: this.decodeUnicode(message.content),
                isFavorited: false,
                favoriteId: null,
                hasFeedback: false,
                feedbackId: null
              });
            }
          });

          // 加载完历史记录后，检查每条AI回答的收藏状态
          await this.checkAllFavoritesStatus();
          
          // 检查每条AI回答的反馈状态
          await this.checkAllFeedbackStatus();

          // 检查是否还有更多历史记录
          // 获取当前会话ID
          const sessionId = localStorage.getItem('sessionId') || 'default';
          
          // 检查总消息数量，确定是否还有更多
          try {
            const countResponse = await fetch(`${process.env.VUE_APP_API_BASE_URL}/api/chat-messages/count?userId=${this.userId}&sessionId=${sessionId}`);
            const countResult = await countResponse.json();
            if (countResult.code === 200) {
              const totalCount = countResult.data;
              // 如果总消息数量大于当前显示的消息数量，说明还有更多
              this.hasMoreHistory = totalCount > result.data.length;
              console.log('总消息数量:', totalCount, '当前显示:', result.data.length, '还有更多:', this.hasMoreHistory);
            } else {
              this.hasMoreHistory = result.data.length >= (this.pageSize * 2); // 因为每次加载的是问答对
            }
          } catch (error) {
            console.error('获取消息总数失败:', error);
            this.hasMoreHistory = result.data.length >= (this.pageSize * 2);
          }
          
          // 滚动到底部
          this.$nextTick(() => {
            this.scrollToBottom();
          });

          console.log('最新历史记录加载完成');
        } else {
          console.log('没有找到历史记录或加载失败:', result.message);
          this.hasMoreHistory = false;
        }
      } catch (error) {
        console.error('加载历史记录失败:', error);
        this.hasMoreHistory = false;
      } finally {
        this.isLoadingHistory = false;
      }
    },

    // 加载更多历史记录
    async loadMoreHistory() {
      if (this.isLoadingMore || !this.hasMoreHistory) {
        return;
      }

      try {
        this.isLoadingMore = true;
        this.currentPage++;
        console.log('开始加载更多历史记录，页码:', this.currentPage);

        // 获取当前会话ID
        const sessionId = localStorage.getItem('sessionId') || 'default';
        
        const response = await fetch(`${process.env.VUE_APP_API_BASE_URL}/api/chat-messages/load-more?userId=${this.userId}&sessionId=${sessionId}&page=${this.currentPage}&size=${this.pageSize}`);
        const result = await response.json();

        if (result.code === 200 && result.data && result.data.length > 0) {
          console.log('成功加载更多历史记录，共', result.data.length, '条消息');
          
          // 在现有消息前面插入历史消息
          const newMessages = [];
          result.data.forEach(message => {
            if (message.messageType === 'QUESTION') {
              newMessages.push({
                type: 'right',
                content: this.decodeUnicode(message.content),
                isFavorited: false,
                favoriteId: null
              });
            } else if (message.messageType === 'ANSWER') {
              newMessages.push({
                type: 'left',
                content: this.decodeUnicode(message.content),
                isFavorited: false,
                favoriteId: null,
                hasFeedback: false,
                feedbackId: null
              });
            }
          });

          // 在数组开头插入新消息
          this.messages.unshift(...newMessages);
          
          // 检查新加载消息的收藏状态
          await this.checkNewMessagesFavoritesStatus(newMessages.length);
          
          // 检查是否还有更多历史记录
          // 获取当前会话ID
          const sessionId = localStorage.getItem('sessionId') || 'default';
          
          // 检查总消息数量，确定是否还有更多
          try {
            const countResponse = await fetch(`${process.env.VUE_APP_API_BASE_URL}/api/chat-messages/count?userId=${this.userId}&sessionId=${sessionId}`);
            const countResult = await countResponse.json();
            if (countResult.code === 200) {
              const totalCount = countResult.data;
              // 如果总消息数量大于当前显示的消息数量，说明还有更多
              this.hasMoreHistory = totalCount > this.messages.length;
              console.log('总消息数量:', totalCount, '当前显示:', this.messages.length, '还有更多:', this.hasMoreHistory);
            } else {
              this.hasMoreHistory = result.data.length >= (this.pageSize * 2); // 因为每次加载的是问答对
            }
          } catch (error) {
            console.error('获取消息总数失败:', error);
            this.hasMoreHistory = result.data.length >= (this.pageSize * 2);
          }
          
          // 保持滚动位置
          this.$nextTick(() => {
            this.maintainScrollPosition(newMessages.length);
          });

          console.log('更多历史记录加载完成');
        } else {
          console.log('没有更多历史记录');
          this.hasMoreHistory = false;
        }
      } catch (error) {
        console.error('加载更多历史记录失败:', error);
        this.hasMoreHistory = false;
      } finally {
        this.isLoadingMore = false;
      }
    },

    // 处理滚动事件
    handleScroll(event) {
      const container = event.target;
      const scrollTop = container.scrollTop;
      
      // 检测是否滚动到顶部
      if (scrollTop <= 100 && this.hasMoreHistory && !this.isLoadingMore) {
        console.log('检测到滚动到顶部，开始加载更多历史记录，scrollTop:', scrollTop);
        this.loadMoreHistory();
      }
      
      // 检测用户是否在手动滚动
      if (Math.abs(scrollTop - this.lastScrollTop) > 10) {
        this.isUserScrolling = true;
        this.autoScrollToBottom = false;
      }
      
      this.lastScrollTop = scrollTop;
    },

    // 滚动到底部
    scrollToBottom() {
      if (this.autoScrollToBottom) {
        const container = this.$refs.messageContainer;
        if (container) {
          container.scrollTop = container.scrollHeight;
        }
      }
    },

    // 保持滚动位置（加载更多历史记录后）
    maintainScrollPosition(newMessageCount) {
      const container = this.$refs.messageContainer;
      if (container) {
        // 计算新消息的高度（估算）
        const estimatedHeight = newMessageCount * 100; // 每条消息大约100px
        container.scrollTop = estimatedHeight;
      }
    },

    // 刷新历史记录（保留原有方法以兼容）
    async refreshHistory() {
      await this.loadChatHistory();
    },

    // 启动单点登录检查定时器
    startSingleLoginCheck() {
      this.singleLoginCheckTimer = setInterval(() => {
        this.checkSingleLoginStatus();
      }, 30000); // 改为每30秒检查一次，减少服务器负担
    },

    // 启动token过期检查定时器
    startTokenExpirationCheck() {
      // 每30分钟检查一次token是否过期
      this.tokenExpirationTimer = setInterval(() => {
        this.checkTokenExpiration();
      }, 30 * 60 * 1000); // 30分钟
    },

    // 立即检查单点登录状态（用于关键操作前检查）
    async checkSingleLoginStatusImmediate() {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          console.warn('Token不存在，无需检查单点登录');
          return false; // 返回false表示检查失败
        }

        const response = await fetch(`${process.env.VUE_APP_API_BASE_URL}/api/auth/check-single-login`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': token
          }
        });

        const result = await response.json();

        if (result.code === 200 && result.isLoggedInElsewhere) {
          console.warn('检测到账户在别的地方登录，当前会话被踢出');
          this.handleKickedOut();
          return true; // 返回true表示被踢出
        } else if (result.code === 200) {
          console.log('单点登录检查通过');
          return false; // 返回false表示检查通过
        } else {
          console.error('单点登录检查失败:', result.message);
          return false; // 返回false表示检查失败
        }
      } catch (error) {
        console.error('检查单点登录状态失败:', error);
        return false; // 网络错误时返回false
      }
    },

    // 检查单点登录状态
    async checkSingleLoginStatus() {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          console.warn('Token不存在，无需检查单点登录');
          return;
        }

        const response = await fetch(`${process.env.VUE_APP_API_BASE_URL}/api/auth/check-single-login`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': token
          }
        });

        const result = await response.json();

        if (result.code === 200 && result.isLoggedInElsewhere) {
          console.warn('检测到账户在别的地方登录，当前会话被踢出');
          this.handleKickedOut();
        } else if (result.code === 200) {
          console.log('单点登录检查通过');
        } else {
          console.error('单点登录检查失败:', result.message);
        }
      } catch (error) {
        console.error('检查单点登录状态失败:', error);
        // 网络错误时不强制退出，继续使用
      }
    },

    // 处理被踢出
    handleKickedOut() {
      // 清除本地存储
      localStorage.removeItem('token');
      localStorage.removeItem('sessionId');
      localStorage.removeItem('displayName');
      localStorage.removeItem('loginAccount');
      localStorage.removeItem('userId');
      
      // 关闭WebSocket连接
      this.closeWebSocket();
      
      // 显示提示信息
      alert('您的账户在别的地方登录，当前会话已被踢出');
      
      // 跳转到登录页面
      this.$router.push('/login');
    },

    // 检查token是否过期
    async checkTokenExpiration() {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          return;
        }

        const response = await fetch(`${process.env.VUE_APP_API_BASE_URL}/api/auth/validate-token`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': token
          }
        });

        const result = await response.json();

        if (result.code !== 200 || !result.valid) {
          console.log('Token已过期，自动退出登录');
          this.handleTokenExpiration();
        }
      } catch (error) {
        console.error('检查token过期失败:', error);
      }
    },

    // 处理token过期
    handleTokenExpiration() {
      // 清除本地存储
      localStorage.removeItem('token');
      localStorage.removeItem('sessionId');
      localStorage.removeItem('displayName');
      localStorage.removeItem('loginAccount');
      localStorage.removeItem('userId');
      
      // 关闭WebSocket连接
      this.closeWebSocket();
      
      // 显示提示信息
      alert('登录已过期，请重新登录');
      
      // 跳转到登录页面
      this.$router.push('/login');
    },

    // 添加页面可见性检测
    setupPageVisibilityDetection() {
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
          console.log('页面重新可见，检查单点登录状态...');
          this.checkSingleLoginStatusImmediate();
        }
      });
    },

    // 收藏相关方法
    async toggleFavorite(message, index) {
      console.log('点击收藏按钮', message, index);
      
      if (message.type !== 'left') {
        console.log('不是AI回答消息，跳过');
        return;
      }

      try {
        const token = localStorage.getItem('token');
        if (!token) {
          alert('请先登录');
          return;
        }

        // 获取对应的问题（前一个消息）
        const questionMessage = this.messages[index - 1];
        if (!questionMessage || questionMessage.type !== 'right') {
          alert('无法找到对应的问题');
          return;
        }

        const question = questionMessage.content;
        const answer = message.content;

        console.log('问题:', question);
        console.log('回答:', answer);

        // 确保消息对象有收藏相关属性
        if (message.isFavorited === undefined) {
          this.$set(message, 'isFavorited', false);
        }
        if (message.favoriteId === undefined) {
          this.$set(message, 'favoriteId', null);
        }

        console.log('当前收藏状态:', message.isFavorited);

        if (message.isFavorited) {
          // 取消收藏
          console.log('取消收藏，favoriteId:', message.favoriteId);
          if (!message.favoriteId) {
            console.log('收藏ID不存在，重新检查收藏状态');
            // 重新检查收藏状态
            await this.checkFavoriteStatus(index);
            // 如果重新检查后仍然没有favoriteId，说明状态不一致，强制设置为未收藏
            if (!this.messages[index].favoriteId) {
              this.$set(this.messages[index], 'isFavorited', false);
              alert('收藏状态异常，已重置为未收藏状态');
              return;
            }
          }
          await this.removeFavorite(message.favoriteId, index);
        } else {
          // 添加收藏
          console.log('添加收藏');
          await this.addFavorite(question, answer, index);
        }
      } catch (error) {
        console.error('收藏操作失败:', error);
        alert('操作失败，请重试');
      }
    },

    async addFavorite(question, answer, messageIndex) {
      try {
        console.log('开始添加收藏', { question, answer, messageIndex });
        const token = localStorage.getItem('token');
        
        // 将内容转换为Unicode格式
        const unicodeQuestion = this.encodeUnicode(question);
        const unicodeAnswer = this.encodeUnicode(answer);
        
        console.log('Unicode格式 - 问题:', unicodeQuestion);
        console.log('Unicode格式 - 回答:', unicodeAnswer);
        
        const response = await fetch(`${process.env.VUE_APP_API_BASE_URL}/api/favorites/add`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': token
          },
          body: JSON.stringify({
            question: unicodeQuestion,
            answer: unicodeAnswer
          })
        });

        const result = await response.json();
        console.log('收藏API响应:', result);

        if (result.code === 200) {
          // 更新消息的收藏状态
          this.$set(this.messages[messageIndex], 'isFavorited', true);
          this.$set(this.messages[messageIndex], 'favoriteId', result.data.id);
          alert('收藏成功');
          console.log('收藏成功，更新消息状态');
          
          // 通知左侧导航更新收藏数量
          this.$emit('favorite-count-changed');
          // 同时使用自定义事件通知
          window.dispatchEvent(new CustomEvent('favoriteCountUpdated'));
        } else {
          alert(result.message || '收藏失败');
        }
      } catch (error) {
        console.error('添加收藏失败:', error);
        alert('收藏失败，请重试');
      }
    },

    async removeFavorite(favoriteId, messageIndex) {
      try {
        console.log('开始取消收藏', { favoriteId, messageIndex });
        
        if (!favoriteId) {
          alert('收藏ID无效');
          return;
        }
        
        const token = localStorage.getItem('token');
        if (!token) {
          alert('请先登录');
          return;
        }
        
        const response = await fetch(`${process.env.VUE_APP_API_BASE_URL}/api/favorites/${favoriteId}`, {
          method: 'DELETE',
          headers: {
            'Authorization': token
          }
        });

        console.log('取消收藏API响应状态:', response.status);
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();
        console.log('取消收藏API响应:', result);

        if (result.code === 200) {
          // 更新消息的收藏状态
          this.$set(this.messages[messageIndex], 'isFavorited', false);
          this.$set(this.messages[messageIndex], 'favoriteId', null);
          alert('取消收藏成功');
          console.log('取消收藏成功，更新消息状态');
          
          // 通知左侧导航更新收藏数量
          this.$emit('favorite-count-changed');
          // 同时使用自定义事件通知
          window.dispatchEvent(new CustomEvent('favoriteCountUpdated'));
        } else {
          alert(result.message || '取消收藏失败');
        }
      } catch (error) {
        console.error('取消收藏失败:', error);
        alert('取消收藏失败，请重试');
      }
    },

    // 检查消息是否已收藏（用于历史记录）
    async checkFavoriteStatus(messageIndex) {
      if (this.messages[messageIndex].type !== 'left') {
        return;
      }

      try {
        const questionMessage = this.messages[messageIndex - 1];
        if (!questionMessage || questionMessage.type !== 'right') {
          return;
        }

        const token = localStorage.getItem('token');
        if (!token) {
          return;
        }

        const question = questionMessage.content;
        const answer = this.messages[messageIndex].content;

        // 将问题转换为Unicode格式进行查询
        const unicodeQuestion = this.encodeUnicode(question);

        const response = await fetch(`${process.env.VUE_APP_API_BASE_URL}/api/favorites/check`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': token
          },
          body: JSON.stringify({
            question: unicodeQuestion
          })
        });

        const result = await response.json();
        console.log(`检查消息 ${messageIndex} 收藏状态:`, result);
        
        if (result.code === 200 && result.data && result.data.isFavorited) {
          this.$set(this.messages[messageIndex], 'isFavorited', true);
          this.$set(this.messages[messageIndex], 'favoriteId', result.data.id);
          console.log(`消息 ${messageIndex} 已收藏，ID: ${result.data.id}`);
        } else {
          // 确保未收藏状态正确设置
          this.$set(this.messages[messageIndex], 'isFavorited', false);
          this.$set(this.messages[messageIndex], 'favoriteId', null);
          console.log(`消息 ${messageIndex} 未收藏`);
        }
      } catch (error) {
        console.error('检查收藏状态失败:', error);
        // 出错时设置为未收藏状态
        this.$set(this.messages[messageIndex], 'isFavorited', false);
        this.$set(this.messages[messageIndex], 'favoriteId', null);
      }
    },

    // 检查所有AI回答的收藏状态
    async checkAllFavoritesStatus() {
      console.log('开始检查所有AI回答的收藏状态');
      
      for (let i = 0; i < this.messages.length; i++) {
        if (this.messages[i].type === 'left') {
          await this.checkFavoriteStatus(i);
        }
      }
      
      console.log('完成所有AI回答的收藏状态检查');
    },

    // 检查新加载消息的收藏状态（用于loadMoreHistory）
    async checkNewMessagesFavoritesStatus(newMessagesCount) {
      console.log(`开始检查新加载的 ${newMessagesCount} 条消息的收藏状态`);
      
      // 检查前newMessagesCount条消息（新插入的消息）
      for (let i = 0; i < newMessagesCount && i < this.messages.length; i++) {
        if (this.messages[i].type === 'left') {
          await this.checkFavoriteStatus(i);
        }
      }
      
      console.log('完成新加载消息的收藏状态检查');
    },

    // 设置输入框内容（用于相关问题点击）
    setInputMessage(content) {
      this.inputMessage = content;
      // 聚焦到输入框
      this.$nextTick(() => {
        const inputElement = this.$refs.messageInput;
        if (inputElement) {
          inputElement.focus();
        }
      });
    },

    // 导出对话记录
    exportChatHistory() {
      try {
        if (this.messages.length === 0) {
          alert('暂无对话记录可导出');
          return;
        }

        let content = '对话记录导出\n';
        content += '导出时间: ' + new Date().toLocaleString() + '\n';
        content += '='.repeat(50) + '\n\n';

        this.messages.forEach((message, index) => {
          const time = new Date(message.timestamp).toLocaleString();
          if (message.type === 'right') {
            content += `[用户 ${time}]\n${message.content}\n\n`;
          } else {
            content += `[AI ${time}]\n${message.content}\n\n`;
          }
        });

        // 创建下载链接
        const blob = new Blob([content], { type: 'text/plain;charset=utf-8' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `对话记录_${new Date().toISOString().slice(0, 10)}.txt`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);

        alert('对话记录导出成功');
      } catch (error) {
        console.error('导出对话记录失败:', error);
        alert('导出对话记录失败');
      }
    },

    // 分享对话
    shareChat() {
      try {
        if (this.messages.length === 0) {
          alert('暂无对话记录可分享');
          return;
        }

        // 生成分享链接（这里可以根据实际需求实现）
        const shareText = '我正在使用AI助手进行对话，快来体验吧！';
        const shareUrl = window.location.origin + '/chat';

        if (navigator.share) {
          // 使用Web Share API
          navigator.share({
            title: 'AI助手对话分享',
            text: shareText,
            url: shareUrl
          });
        } else {
          // 复制到剪贴板
          const shareContent = `${shareText}\n${shareUrl}`;
          navigator.clipboard.writeText(shareContent).then(() => {
            alert('分享链接已复制到剪贴板');
          }).catch(() => {
            alert('复制分享链接失败');
          });
        }
      } catch (error) {
        console.error('分享对话失败:', error);
        alert('分享对话失败');
      }
    },

    // 问题反馈相关方法
    // 打开问题反馈弹窗
    openFeedbackDialog(message, index) {
      console.log('打开问题反馈弹窗', message, index);
      
      // 设置当前反馈的消息
      this.feedbackMessageIndex = index;
      this.feedbackAnswer = message.content;
      
      // 清空疑问内容（用户输入的内容）
      this.feedbackQuestion = '';
      
      // 显示弹窗
      this.showFeedbackDialog = true;
    },

    // 关闭问题反馈弹窗
    closeFeedbackDialog() {
      this.showFeedbackDialog = false;
      this.feedbackQuestion = '';
      this.feedbackAnswer = '';
      this.feedbackMessageIndex = -1;
    },

    // 获取问题内容（用于反馈）
    getQuestionForFeedback() {
      if (this.feedbackMessageIndex === -1) return '';
      
      // 向前查找最近的问题
      for (let i = this.feedbackMessageIndex - 1; i >= 0; i--) {
        if (this.messages[i].type === 'right') {
          return this.messages[i].content;
        }
      }
      return '';
    },

    // 获取回答内容（用于反馈）
    getAnswerForFeedback() {
      if (this.feedbackMessageIndex === -1) return '';
      return this.messages[this.feedbackMessageIndex].content;
    },

    // 提交问题反馈
    async submitFeedback() {
      if (!this.feedbackQuestion.trim()) {
        alert('请输入您的疑问');
        return;
      }

      if (this.feedbackQuestion.length > 300) {
        alert('疑问内容不能超过300字');
        return;
      }

      try {
        this.isSubmittingFeedback = true;

        const token = localStorage.getItem('token');
        if (!token) {
          alert('请先登录');
          return;
        }

        const questionContent = this.getQuestionForFeedback();
        const answerContent = this.getAnswerForFeedback();

        const response = await fetch(`${process.env.VUE_APP_API_BASE_URL}/api/feedback/create`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({
            questionContent: questionContent,
            answerContent: answerContent,
            questionFeedback: this.feedbackQuestion
          })
        });

        const result = await response.json();
        console.log('问题反馈API响应:', result);

        if (result.code === 200) {
          // 更新消息的反馈状态
          this.$set(this.messages[this.feedbackMessageIndex], 'hasFeedback', true);
          this.$set(this.messages[this.feedbackMessageIndex], 'feedbackId', result.data.id);
          
          // 强制更新视图
          this.$forceUpdate();
          
          alert('问题反馈提交成功');
          console.log('问题反馈提交成功');
          
          // 关闭弹窗
          this.closeFeedbackDialog();
        } else {
          alert(result.message || '问题反馈提交失败');
        }
      } catch (error) {
        console.error('提交问题反馈失败:', error);
        alert('问题反馈提交失败，请重试');
      } finally {
        this.isSubmittingFeedback = false;
      }
    },

    // 检查消息是否有反馈
    async checkFeedbackStatus(messageIndex) {
      try {
        const message = this.messages[messageIndex];
        if (!message || message.type !== 'left') {
          return;
        }

        // 获取对应的问题（前一个消息）
        const questionMessage = this.messages[messageIndex - 1];
        if (!questionMessage || questionMessage.type !== 'right') {
          this.$set(this.messages[messageIndex], 'hasFeedback', false);
          this.$set(this.messages[messageIndex], 'feedbackId', null);
          return;
        }

        const question = questionMessage.content;
        const answer = message.content;

        // 将问题转换为Unicode格式进行查询
        const unicodeQuestion = this.encodeUnicode(question);

        const token = localStorage.getItem('token');
        if (!token) {
          this.$set(this.messages[messageIndex], 'hasFeedback', false);
          this.$set(this.messages[messageIndex], 'feedbackId', null);
          return;
        }

        const response = await fetch(`${process.env.VUE_APP_API_BASE_URL}/api/feedback/check`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({
            questionContent: unicodeQuestion,
            answerContent: this.encodeUnicode(answer)
          })
        });

        const result = await response.json();
        if (result.code === 200 && result.data) {
          this.$set(this.messages[messageIndex], 'hasFeedback', true);
          this.$set(this.messages[messageIndex], 'feedbackId', result.data.id);
        } else {
          this.$set(this.messages[messageIndex], 'hasFeedback', false);
          this.$set(this.messages[messageIndex], 'feedbackId', null);
        }
        
      } catch (error) {
        console.error('检查反馈状态失败:', error);
        this.$set(this.messages[messageIndex], 'hasFeedback', false);
        this.$set(this.messages[messageIndex], 'feedbackId', null);
      }
    },

    // 检查所有AI回答的反馈状态
    async checkAllFeedbackStatus() {
      console.log('开始检查所有AI回答的反馈状态');
      
      for (let i = 0; i < this.messages.length; i++) {
        if (this.messages[i].type === 'left') {
          await this.checkFeedbackStatus(i);
        }
      }
      
      console.log('完成所有AI回答的反馈状态检查');
    }

  }
}
</script>